import { BlockTypes } from "./block-types";
import { BlockConfigMap } from "./block-base";

import { userConfig } from "./block-configs/user";
import { appServerConfig } from "./block-configs/app-server";
import { autoScalingGroupConfig } from "./block-configs/auto-scaling-group";
import { databaseConfig } from "./block-configs/database";
import { noSqlDbConfig } from "./block-configs/no-sql-db";
import { graphDbConfig } from "./block-configs/graph-db";
import { documentDbConfig } from "./block-configs/document-db";
import { s3BucketConfig } from "./block-configs/s3-bucket";
import { passthroughConfig } from "./block-configs/passthrough";
import { dbReadReplicaConfig } from "./block-configs/db-read-replica";
import { loadBalancerConfig } from "./block-configs/load-balancer";
import { cdnConfig } from "./block-configs/cdn";
import { cacheConfig } from "./block-configs/cache";
import { lambdaConfig } from "./block-configs/lambda";
import { queueConfig } from "./block-configs/queue";
import { networkLoadBalancerConfig } from "./block-configs/network-load-balancer";
import { arrowConfig } from "./block-configs/arrow";
import { textBoxConfig } from "./block-configs/text-box";

export * from "./block-base";

export { autoScalingGroupSideEffects } from "./block-configs/auto-scaling-group";
export { cacheSideEffects } from "./block-configs/cache";
export { lambdaSideEffects } from "./block-configs/lambda";
export { passthroughSideEffects } from "./block-configs/passthrough";

export const blockConfigs: BlockConfigMap = {
  [`${BlockTypes.USER}`]: userConfig,
  [`${BlockTypes.APP_SERVER}`]: appServerConfig,
  [`${BlockTypes.AUTO_SCALING_GROUP}`]: autoScalingGroupConfig,
  [`${BlockTypes.DATABASE}`]: databaseConfig,
  [`${BlockTypes.NO_SQL_DB}`]: noSqlDbConfig,
  [`${BlockTypes.GRAPH_DB}`]: graphDbConfig,
  [`${BlockTypes.DOCUMENT_DB}`]: documentDbConfig,
  [`${BlockTypes.S3_BUCKET}`]: s3BucketConfig,
  [`${BlockTypes.PASSTHROUGH}`]: passthroughConfig,
  [`${BlockTypes.DB_READ_REPLICA}`]: dbReadReplicaConfig,
  [`${BlockTypes.LOAD_BALANCER}`]: loadBalancerConfig,
  [`${BlockTypes.CDN}`]: cdnConfig,
  [`${BlockTypes.CACHE}`]: cacheConfig,
  [`${BlockTypes.LAMBDA}`]: lambdaConfig,
  [`${BlockTypes.QUEUE}`]: queueConfig,
  [`${BlockTypes.NETWORK_LOAD_BALANCER}`]: networkLoadBalancerConfig,
  [`${BlockTypes.ARROW}`]: arrowConfig,
  [`${BlockTypes.TEXT_BOX}`]: textBoxConfig,
};

export const starterBlocks = [
  BlockTypes.APP_SERVER,
  BlockTypes.DATABASE,
  BlockTypes.DB_READ_REPLICA,
  BlockTypes.NO_SQL_DB,
  BlockTypes.LOAD_BALANCER,
  BlockTypes.NETWORK_LOAD_BALANCER,
  BlockTypes.CDN,
  BlockTypes.AUTO_SCALING_GROUP,
  BlockTypes.CACHE,
  BlockTypes.LAMBDA,
  BlockTypes.QUEUE,
  BlockTypes.GRAPH_DB,
  BlockTypes.DOCUMENT_DB,
  BlockTypes.S3_BUCKET,
  BlockTypes.PASSTHROUGH,
];

export function getBlockConfig(blockType: BlockTypes) {
  return blockConfigs[blockType];
}
